import React, { Component, Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: Buying by negotiation</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs
                  crumbs={[
                    { url: '/ways-to-purchase', name: 'Ways to purchase' },
                    {
                      url: '/ways-to-purchase/negotiation',
                      name: 'Negotiation',
                    },
                  ]}
                />
                <h2 className="lead text-center">Negotiation</h2>
                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    ​
                    <p>
                      A seller may choose to sell by negotiation when it’s difficult to estimate the market price of a
                      property. There is no end date for offers. Buyers make offers based on what they think the
                      property is worth in the current market.
                    </p>
                    <p>
                      Properties being sold ‘by negotiation’ is an opportunity for the buyer to put an offer in on a
                      property without having the deadline of a tender sale. A Sale and Purchase agreement is submitted
                      by the potential buyer. The vendor will consider your offer including the settlement date and any
                      conditions. They may either accept or reject your offer, or negotiate until an offer is made that
                      is acceptable to both parties. If you are not the only buyer engaged in negotiations with the
                      vendor, then the real estate agent should make it clear you that it is a competitive offer
                      situation. In this situation, you only have one chance to make an offer, so you should make the
                      best offer you are able to.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ways_to_purchase/Negotiation.jsx